import { useTranslation } from 'react-i18next';
import type { ILayoutPreviewCardProps } from './ILayoutPreviewCardProps';
import { layoutPreview } from './layoutPreview';

/**
 * Картка «Перегляд» (прототип v4 gsPreview): зразок групи полів з поточними ширинами — сітка з колонками по 0,6 одиниці поля, плитки 44px
 * з підписом і класом ширини (S — найсвітліша, L — акцентна на весь рядок).
 */
export function LayoutPreviewCard({ layout }: ILayoutPreviewCardProps) {
  const { t } = useTranslation();
  return (
    <section className="cu-panel" aria-label={t('sysCust.layout.preview')}>
      <div className="cu-titles"><div className="sp-eyebrow">{t('sysCust.layout.preview')}</div><div className="sp-muted">{t('sysCust.layout.previewDesc')}</div></div>
      <div className="cu-preview" style={{ gridTemplateColumns: `repeat(auto-fill, minmax(${Math.round(layout.unit * 0.6)}px, 1fr))` }}>
        {layoutPreview(layout).map((p) => (
          <div key={p.key} className={`cu-preview__item is-${p.width}`} style={{ gridColumn: p.span }}>
            <span className="cu-ellipsis">{t(`sysCust.layout.sample.${p.key}`)}</span><span className="cu-preview__w">{p.width}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
